export const DEFAULT_LANGUAGE_CODE = "EN";
